import { FC } from 'react';
import { FieldRenderProps } from 'react-final-form';

type TableFilterCheckboxFieldProps = FieldRenderProps<
  string,
  HTMLElement,
  boolean
> & {
  labelText?: string;
};

const TableFilterCheckboxField: FC<TableFilterCheckboxFieldProps> = ({
  input,
  labelText,
  ...otherProps
}) => {
  return (
    <div className="relative w-full">
      <input
        id={input.name}
        checked={!!input.value}
        onChange={(e) => input.onChange(e.target.checked)}
        type="checkbox"
        className=" rounded text-sky-900 focus:ring-2 focus:ring-sky-800"
        autoComplete="off"
        {...otherProps}
      />
      <label htmlFor={input.name} className="ml-2 text-sm">
        {labelText || input.name}
      </label>
    </div>
  );
};

export default TableFilterCheckboxField;
